import { get, post, del, put } from '@api/request';
import { defaultPageSize } from '@constants';

export async function fetchMenuprofiles(
  { appraisalService },
  authenticationToken,
  {
    pageSize = defaultPageSize,
    page = 1,
    sortField,
    sortDirection,
    searchOptions,
  },
) {
  let url = `${appraisalService}/appraisal/screenconfiguration/menuprofiles`;
  url += `?page=${page}&pageSize=${pageSize}`;
  if (sortField && sortDirection) {
    url += `&sortField=${sortField}&sortDirection=${sortDirection}`;
  }
  if (
    searchOptions &&
    searchOptions.menuPropertyTypes &&
    searchOptions.menuPropertyTypes.length > 0
  ) {
    searchOptions.menuPropertyTypes.forEach(option => {
      url += `&menuPropertyTypes[]=${option}`;
    });
  }
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchMenuprofile(
  { appraisalService },
  authenticationToken,
  { menuprofileId },
) {
  const url = `${appraisalService}/appraisal/screenconfiguration/menuprofile/${menuprofileId}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateMenuprofile(
  { appraisalService },
  authenticationToken,
  { menuprofileId, data },
) {
  const url = `${appraisalService}/appraisal/screenconfiguration/menuprofile/${menuprofileId}`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function createMenuprofile(
  { appraisalService },
  authenticationToken,
  { data },
) {
  const url = `${appraisalService}/appraisal/screenconfiguration/menuprofiles`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export async function deleteMenuprofile(
  { appraisalService },
  authenticationToken,
  { menuprofileId },
) {
  const url = `${appraisalService}/appraisal/screenconfiguration/menuprofile/${menuprofileId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function duplicateMenuprofile(
  { appraisalService },
  authenticationToken,
  { menuprofileId },
) {
  const url = `${appraisalService}/appraisal/screenconfiguration/menuprofile/${menuprofileId}/duplicate`;
  const { body } = await post(authenticationToken, url);
  return body;
}

// Menu Defaults

export async function fetchUserDefaultMenus(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/menuprofile/userdefaults`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchUserDefaultMenu(
  { appraisalService },
  authenticationToken,
  { menuDefaultId },
) {
  const url = `${appraisalService}/appraisal/menuprofile/userdefault/${menuDefaultId}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createUserDefaultMenu(
  { appraisalService },
  authenticationToken,
  { data },
) {
  const url = `${appraisalService}/appraisal/menuprofile/userdefaults`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export async function updateUserDefaultMenu(
  { appraisalService },
  authenticationToken,
  { menuDefaultId, data },
) {
  const url = `${appraisalService}/appraisal/menuprofile/userdefault/${menuDefaultId}`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function deleteUserDefaultMenu(
  { appraisalService },
  authenticationToken,
  { menuDefaultId },
) {
  const url = `${appraisalService}/appraisal/menuprofile/userdefault/${menuDefaultId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function fetchPropertiesAvailableForUser(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/menuprofile/proptypesavailableforuser`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAuthorizedMenuProfiles(
  { appraisalService },
  authenticationToken,
  { propertyType },
) {
  const url = `${appraisalService}/appraisal/menuprofile/availableforuser/${propertyType}`;
  const { body } = await get(authenticationToken, url);
  return body;
}
